import { useRef, useState } from 'react';
import useHandleClickOutside from '../../hooks/utils/useHandleClickOutside';

const Dropdown = ({ links = [], type = 'primary', buttonContent, buttonClass = [] }) => {
    const [open, setOpen] = useState(false);

    const dropdownRef = useRef(null);

    const btnClasses = [...['toggle-button'], ...buttonClass];

    useHandleClickOutside([dropdownRef], open, setOpen);

    const toggleDropdown = () => setOpen((prev) => !prev);

    return (
        <div className={`dropdown ${type}-dropdown`} ref={dropdownRef}>
            <button
                className={btnClasses.join(' ')}
                type="button"
                onClick={toggleDropdown}
                aria-expanded={open}
            >
                <span className="sr-only">Toggle {type} navigation</span>

                {buttonContent ? (
                    buttonContent
                ) : type === 'primary' ? (
                    <div>
                        <img src="/assets/images/menu-icons/bars-small.svg" alt="" /> MENY
                    </div>
                ) : (
                    <img
                        className="secondary-dropdown-btn-image"
                        src="/assets/images/menu-icons/user-pink-fill.svg"
                        alt=""
                    />
                )}
            </button>

            <ul className={`dropdown-menu ${open ? 'open' : ''}`}>
                {links.map((link) => (
                    <li className={link.class} key={link.href}>
                        <a href={link.href}>
                            {link.icon_path && <img src={link.icon_path} alt="" />}
                            {link.label}
                            {link.count > 0 && <span className="nav-badge">{link.count}</span>}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Dropdown;
